import { combineReducers } from "redux";
import byDatasourceIdReducer, { ByDatasourceIdState } from "./byDatasourceId";
import idsOfCheckingDatasourcesReducer, {
  IdsOfCheckingDatasourcesState,
} from "./idsOfCheckingDatasources";

const hegMappingReducerState = combineReducers({
  byDatasourceId: byDatasourceIdReducer,
  idsOfCheckingDatasources: idsOfCheckingDatasourcesReducer,
});

export default hegMappingReducerState;

export type HegMappingSlice = {
  byDatasourceId: ByDatasourceIdState;
  idsOfCheckingDatasources: IdsOfCheckingDatasourcesState;
};
